<template>
  <div class="header-settings">
    <cnd-icon name="cnd-setting" @click="handleSetting" />
  </div>
</template>

<script>
export default {
  name: 'HeaderSettings',
  methods: {
    handleSetting() {
      this.$emit('handleSetting')
    }
  }
}
</script>
